import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { fetchReview } from '../../redux/actions/review';
import Rating from '../rating/Rating';
import { BsPencilFill } from "react-icons/bs";



const ProjectCard=({dispatch, review})=> {
    const {  id } = useParams();

    // console.log(id);
    useEffect(()=>{
        dispatch(fetchReview(id))
       },[dispatch, id])

  
   
        return (
            <section className="live-auctions-area pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {/* Intro */}
                            <div className="intro d-flex justify-content-between align-items-end m-0">
                                <div className="intro-content">
                                    
                                    <h3 className="mt-3 mb-0">View Reviews</h3>
                                </div>
                                <div className="intro-btn">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className=" items">
                            <div className="row">
                                {/* Single Slide */}
                                {review&& review.map((item, idx) => {
                                    return (
                                        <div key={`auc_${idx}`} className="p-2 col-12 col-md-4 item">
                                            <div className="card pt-1">
                                                
                                                {/* Card Caption */}
                                                <div className="card-caption col-12 p-0">
                                                    {/* Card Body */}
                                                    <div className="card-body pt-0">
                                                        
                                                       
                                                        <Link className="seller d-flex align-items-center my-3" to="/">
                                                            <img className="avatar-md rounded-circle" src={item.project.image} alt="" />
                                                            <span className="ml-4">
                                                            <p className=" mb-0 p-0">{item.project.projectname}</p>

<div className='rating'>
<div className='star-rating'>

<Rating rating={item.rating}/>
</div>
<div className="risk-rating">
    <span className={item.risk==='low'? 'badge badge-success' : item.risk==='medium'? 'badge badge-warning' :'badge badge-danger'}>{item.risk}</span>
</div>


</div>
                                                            </span>
                                                        </Link>
                                                        <div className="card-bottom ">
                                                            <p className='pb-0 mb-0 text-white'>{item.review}</p>
                                                            <br />
                                                            <span className='text-muted'>
                                                                <p className='d-inline'>
                                                                {item.wallet}</p>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="swiper-pagination" />
                        </div>
                    </div>
                </div>
            </section>
        );
   
}

function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      
      review: state.review.reviewData
    };
  }
export default connect(mapStateToProps)(ProjectCard);